import React from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const withoutMegaPack = ['Llegas a cada clase sin una secuencia clara de qué explicar primero.', 'Pasas horas buscando actividades que nunca terminan de adaptarse a tu curso.', 'Tus materiales están dispersos entre carpetas, archivos, libros y documentos sueltos.', 'Repites las mismas explicaciones sin contar con recursos visuales de apoyo.', 'Preparas evaluaciones y recuperaciones desde cero cada vez.', 'Improvisas experiencias de laboratorio sin guías de registro ni criterios claros.', 'Terminas la semana con más planificación pendiente.', 'Cada nuevo ciclo escolar vuelves a crear materiales que ya habías preparado antes.'];
const withMegaPack = ['Encuentras cada contenido organizado según el nivel y la secuencia correspondiente.', 'Preparas tu próxima clase en minutos sin comenzar desde una página en blanco.', 'Tienes explicaciones, fichas, actividades y evaluaciones reunidas en un solo lugar.', 'Explicas los contenidos más complejos mediante imágenes, esquemas y ejemplos claros.', 'Utilizas actividades en formatos A y B para practicar, evaluar y realizar recuperaciones.', 'Aplicas experiencias de laboratorio con guías, protocolos y registros listos.', 'Terminas la semana con tus próximas clases organizadas.', 'Reutilizas y adaptas el material durante los siguientes ciclos escolares.'];
export function PainPoints() {
  return <section className="py-8 md:py-16 px-4 bg-sky-200/50" data-id="element-112" data-mp="1g22ot4n71o8o">
      <div className="max-w-6xl mx-auto" data-id="element-113" data-mp="1b3hq59nlbcmc">
        <div className="max-w-4xl mx-auto text-center mb-6 md:mb-10" data-id="element-114" data-mp="1b4khfiotrh2s">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-black text-slate-900 leading-tight mb-3 md:mb-4" data-id="element-115" data-mp="1p3ac6ro694nz">
            La diferencia entre preparar todo desde cero y trabajar con Química
            Visual
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-600 font-bold text-sm md:text-lg leading-relaxed" data-id="element-116" data-mp="1t43pxci0wx1k">
            No necesitas más recursos dispersos. Necesitas un sistema que te
            permita encontrar y utilizar lo que necesitas para cada clase.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-117" data-mp="1ehaieteqwvjx">
          <motion.article initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-stone-50 border border-stone-200 rounded-3xl p-5 md:p-8 shadow-lg shadow-slate-900/5" data-id="element-118" data-mp="1jflqaylhcvzi">
            <h3 className="text-slate-900 font-black text-xl md:text-2xl leading-tight mb-5 md:mb-6" data-id="element-119" data-mp="vphpt03l9ccq">
              ❌ Sin el MegaPack Química Visual
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-120" data-mp="o45qemtxjkiy">
              {withoutMegaPack.map(item => <li key={item} className="flex items-start gap-3" data-id="element-121" data-mp="j7opes1mtbog">
                  <span className="mt-0.5 shrink-0 rounded-lg bg-rose-100 p-1" data-id="element-122" data-mp="e7aumbp1jy8d">
                    <XIcon className="w-4 h-4 text-rose-600 stroke-[3px]" data-id="element-123" data-mp="a6qv51gzwij2" />
                  </span>
                  <span className="text-slate-700 font-semibold text-sm md:text-base leading-relaxed" data-id="element-124" data-mp="5749q4r0jvz6">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.08
        }} className="bg-blue-600 border border-blue-700 rounded-3xl p-5 md:p-8 shadow-xl shadow-blue-900/20" data-id="element-125" data-mp="3rm76fj9jw1k7">
            <h3 className="text-white font-black text-xl md:text-2xl leading-tight mb-5 md:mb-6" data-id="element-126" data-mp="3dnz9vcgff29k">
              ✅ Con el MegaPack Química Visual
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-127" data-mp="1lkl81x73ww2h">
              {withMegaPack.map(item => <li key={item} className="flex items-start gap-3" data-id="element-128" data-mp="17urjlfzikdta">
                  <span className="mt-0.5 shrink-0 rounded-lg bg-white/15 p-1" data-id="element-129" data-mp="17s5a3at2bo8f">
                    <CheckCircle2Icon className="w-4 h-4 text-white" data-id="element-130" data-mp="1crhyw13hv5dn" />
                  </span>
                  <span className="text-blue-50 font-semibold text-sm md:text-base leading-relaxed" data-id="element-131" data-mp="xuilfwlyoib9">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.article>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mt-7 md:mt-10" data-id="element-132" data-mp="oxqd1qqba5n8">
          <p className="text-slate-900 font-black text-lg md:text-2xl leading-snug max-w-3xl mx-auto mb-5 md:mb-7" data-id="element-133" data-mp="2o881794srd1z">
            Menos tiempo buscando y preparando. Más tiempo enseñando y
            acompañando a tus estudiantes.
          </p>
          <motion.button animate={{
          boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 30px rgba(34,197,94,0.5)', '0 0 15px rgba(34,197,94,0.2)'],
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.97
        }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full max-w-md bg-green-600 hover:bg-green-700 text-white font-black text-sm md:text-xl py-5 md:py-6 px-6 rounded-2xl shadow-[0_10px_30px_rgba(34,197,94,0.3)] uppercase tracking-tight" data-id="element-134" data-mp="2tewn72y2mxyy">
            ⚗️ OBTENER ACCESO AHORA
          </motion.button>
        </motion.div>
      </div>
    </section>;
}